import Rect from '../../fun-js-lib/geometry/Rect'
import { drawFrame, fillStyled } from '../canvasDraw'

export function mainFrameRect () {
  return Rect.plain({ x: 210, y: 200, w: 2580, h: 1780 })
}

export function pageNumberRect () {
  let frame = mainFrameRect()
  return Rect.plain({
    x: frame.x + frame.w - 115,
    y: frame.y + 250 - 170,
    w: 111,
    h: 171
  })
}

/**
 * Draws biggest rectangle of daily page
 * @param {CanvasRenderingContext2D} context 
 * @param {string} color 
 */
export function drawMainFrame (context, color) {
  let frame = mainFrameRect()
  fillStyled(context, color, () => 
    drawFrame(context, frame, 5))
}
